import { render, staticRenderFns } from "./HospitalMap.vue?vue&type=template&id=d6715a4c&scoped=true&"
import script from "./HospitalMap.vue?vue&type=script&lang=js&"
export * from "./HospitalMap.vue?vue&type=script&lang=js&"
import style0 from "./HospitalMap.vue?vue&type=style&index=0&id=d6715a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6715a4c",
  null
  
)

export default component.exports